import React from 'react';

const ReadBooks = () => {
  const books = [
    {
      id: 1,
      title: "The Seven Husbands of Evelyn Hugo",
      author: "Taylor Jenkins Reid",
      coverUrl: "https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1664458703i/32620332.jpg",
      meetingDate: "September 7, 2024"
    },
    {
      id: 2,
      title: "The Thursday Murder Club",
      author: "Richard Osman",
      coverUrl: "https://pictures.abebooks.com/isbn/9781984880963-uk.jpg",
      meetingDate: "August 3, 2024"
    },
  ];

  return (
    <div className="p-4 shadow-lg bg-slate-100 drop-shadow-lg rounded-xl lg:col-span-4">
      <h2 className="pt-1 pb-2 pl-3 text-3xl font-extrabold leading-tight font-playfair-display">
        Read Books
      </h2>
      <div className="pt-2">
        {books.map(book => (
          <div key={book.id} className="p-2 m-1 mt-2 bg-white border-2 border-white rounded-md shadow-md border-opacity-30 shadow-slate-400">
            <div className="grid grid-cols-6 pl-2 text-lg">
              <div className="col-span-2">
                <img src={book.coverUrl} alt={book.title} className="object-cover mb-4 shadow-lg h-28 w-26 shadow-slate-700" />
              </div>
              <div className="col-span-4">
                <p>{book.title}, {book.author}</p>
                <p>Meeting: {book.meetingDate}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReadBooks;